var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"process"},[_c('p',{staticClass:"text-h6"},[_vm._v("参加手順")]),_c('v-card',{staticClass:"mb-8 how-to-join-card",attrs:{"flat":"","outlined":""}},[_c('div',{staticClass:"how-to-join-text pa-4",domProps:{"innerHTML":_vm._s(_vm.howToJoin)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }